module.exports = "pegasus_template/assets/blue-ghost-facebook.png";